import React, { useEffect, useRef, useState } from "react";
import { isEmergencyOptions, localAttributes } from "assets/constants";
import { KeyValuePair, objectTypeProps } from "types";
import "instantsearch.css/themes/satellite.css";
import styles from "./SearchMedicalCenters.module.scss";
import Text from "components/text/Text";
import { getAllClassNames, getHebDayByCurentDay, isDev, setParams } from "helpers";
import strings from "assets/strings";
import { visitDaysOptions, visitHoursOptions } from "assets/constants";
import { ArrowLeft, ArrowUp } from "assets/icons";
import Button from "components/buttons/button/Button";
import Popup from "components/popup/Popup";
import { CustomLocalSearchInput } from "components/inputs/customLocalSearchInput/CustomLocalSearchInput";
import { CustomCheckboxesLocal } from "components/buttons/customCheckboxesLocal/CustomCheckboxesLocal";
import settings from "assets/mergeSettings";
import { AlertPopup } from "components/popup/alertPopup/AlertPopup";
import { DropdownCheckboxes } from "components/dropdownCheckboxes/DropdownCheckboxes";

export function SearchMedicalCenters(props: objectTypeProps) {
  const { objectType } = props;
  const [expanded, setExpanded] = useState(false);
  const [medicalServices, setMedicalServices] = useState<string[]>([]);
  const [city, setCity] = useState("");
  const [name, setName] = useState("");
  const [daysOfWeek, setDaysOfWeek] = useState<string[]>([])
  const [workHours, setWorkHours] = useState<string[]>([])  
  const [isEmergency, setIsEmergency] = useState(false)
  const divExpandRef = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  let searchResultsPage: string = '';
  switch (objectType) {
    case 1:
      searchResultsPage = settings.doctorSearchResults;
      break;
    case 2:
      searchResultsPage = settings.dietSearchResults;
      break;
    case 3:
      searchResultsPage = settings.socialWorkerSearchResults;
      break;
    case 4:
      searchResultsPage = settings.medicalCenterSearchResults;
      break;
    case 5:
      searchResultsPage = settings.opticaSearchResults;
      break;
    case 6:
      searchResultsPage = settings.emergencySearchResults;
      break;
    case 7:
      searchResultsPage = settings.pharmacySearchResults;
      break;
    case 8:
      searchResultsPage = settings.womenEmergencySearchResults;
      break;
    case 9:
      searchResultsPage = settings.dentalSearchResults;
      break;
  }

  const handelIsEmergency = (selectedData: string[]) => {
    setIsEmergency(selectedData.includes('true'))
  }

  useEffect(() => {
    if (isEmergency) {      
      setDaysOfWeek([getHebDayByCurentDay()])
    }
  }, [isEmergency])

  const onSubmit = (event: any) => {
    event.preventDefault();

    if (objectType == 1 && !medicalServices && !name) {
      handleToggleVisibility();
    } else if (objectType != 1 && objectType != 6 && objectType != 9 && !city && !name) {
      handleToggleVisibility();
    }

    else {
      const formData: KeyValuePair[] = [
        { key: `${[localAttributes.localMedicalServicesApiKey]}`, value: medicalServices.join(',') },
        { key: `${[localAttributes.localOuterServiceName]}`, value: name },
        //{ key: `${[localAttributes.localOuterServiceQuery]}`, value: name },
        { key: `${[localAttributes.localCityCodeFieldName]}`, value: city },
        { key: `${[localAttributes.localdaysOfWeekFieldName]}`, value: daysOfWeek.join(',') },
        { key: `${[localAttributes.localWorkHoursFieldName]}`, value: workHours.join(',') },
      ];

      if (city && city.split(',').length == 1) {
        const cities = localStorage.getItem("cities");
        const citiesArr = cities && JSON.parse(cities);
        const locLat = citiesArr.find((c: any) => c.cityCode === city)?.latitude;
        const locLLong = citiesArr.find((c: any) => c.cityCode === city)?.longitude;
        formData.push({ key: `${[localAttributes.localLocFieldName]}`, value: `${locLat},${locLLong}` }, { key: `${[localAttributes.localRadiusFieldName]}`, value: "10000" });
      }
      window.location.href = `${searchResultsPage}?${setParams(formData)}`;
    }
  };

  useEffect(() => {
    if (divExpandRef.current && expanded) {
      const firstInput = divExpandRef.current.querySelector('input');
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, [expanded]);

  const handleToggleVisibility = () => {
    if (popupRef.current) {
      popupRef.current.classList.toggle('show');
    }
  };

  return (
    <div
      className={getAllClassNames([
        "ais-InstantSearch",
        isDev() && styles.devContainer,
      ])}
    >

      <div className={styles.container}>
        <div
          className={getAllClassNames([
            styles.searchDiv,
            expanded && styles.noBorderBottom,
          ])}
        >
          <CustomLocalSearchInput
            popupProps={{
              title: '',
              subTitle: '',
              placeholder: '',
              keyToNormalize: 'name',
              labelToNormalize: 'name',
              onSubmit: () => { },
            }}
            enableFreeText
            attribute={localAttributes.localDoctorNamesApiKey}
            title={strings.searchMedicalCenters.name}
            queryParams={[{ key: 'objectType', value: objectType }]}

            onChange={(value: string) => setName(value)}
            onReset={() => setName('')}
          />
          <CustomLocalSearchInput
            multiSelect
            isPopup
            popupProps={{
              title: strings.globalStrings.chooseCity,
              subTitle: strings.globalStrings.canChooseCity,
              placeholder: strings.globalStrings.searchCity,
              keyToNormalize: 'cityCode',
              labelToNormalize: 'city',
              onSubmit: () => { },
            }}
            placeholder={strings.globalStrings.cityPlaceholder}

            enableFreeText
            attribute={localAttributes.localCitiesApiKey}
            title={strings.globalStrings.city}
            queryParams={[{ key: 'objectType', value: objectType }]}
            onChange={(value: string) => { setCity(value) }}
            onReset={() => setCity('')}
          />
          {objectType == 9 && <DropdownCheckboxes
            title={strings.searchDoctors.medicalField}
            objectType="9"
            attribute={localAttributes.localMedicalApiKey}
            keyToNormalize={localAttributes.localMedicalFieldName}
            labelToNormalize={localAttributes.localMedicalFieldName}
            setQueryParams={(values: string[]) => setMedicalServices(values)}
            placeholder={strings.searchMedicalCenters.medicalFieldPlaceholder}
          />
          }
        </div>
        {expanded && (
          <div className={styles.divExpand} ref={divExpandRef}>
            <CustomCheckboxesLocal
              isFlex
              onSetSelected={(selectedData: string[]) => setDaysOfWeek(selectedData)}
              title={strings.globalStrings.visitDays}
              options={visitDaysOptions}
              selectedCheckboxes={daysOfWeek}
            />
            {objectType === 6 && <CustomCheckboxesLocal
              isFlex
              onSetSelected={(selectedData: string[]) => handelIsEmergency(selectedData)}           
              options={isEmergencyOptions}
              selectedCheckboxes={isEmergency ? ['true'] : []}
            />
            }
            {(objectType != 6 && objectType != 8) &&
              <CustomCheckboxesLocal
                onSetSelected={(selectedData: string[]) => setWorkHours(selectedData)}
                title={strings.globalStrings.visitHours}
                options={visitHoursOptions}
                selectedCheckboxes={workHours}
              />
            }
          </div>
        )}
        {settings.showAdvanceSearch ?
          <div className={styles.divBottom}>
            <div>
              <Text
                onClick={() => setExpanded(!expanded)}
                className={styles.textAdvance}
                text={expanded ? strings.globalStrings.closeAdvancedSearch : strings.globalStrings.advanceSearch}
              />
              {expanded ? (
                <ArrowUp className={styles.icon} />
              ) : (
                <ArrowLeft className={styles.icon} />
              )}
            </div>
            <Button
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div> :
          <div className={styles.divBottomNoAavanced}>
            <Button
              onClick={onSubmit}
              text={strings.globalStrings.search}
              replaceClassName={styles.button}
            />
          </div>
        }
      </div>
      {
        <Popup
        ref={popupRef}
          onClose={() => handleToggleVisibility()}
          height={284}
          width={550}
          style={{ paddingBottom: '0px' }}
        >
          <AlertPopup
            title={strings.errorMessages.notice}
            subTitle={strings.errorMessages.requiredProperties}
            showButton
            buttonText={strings.globalStrings.close}
            onClose={() => handleToggleVisibility()}
          ></AlertPopup>
        </Popup>
      }
    </div>
  );
}
